import * as React from "react"

export default function ConfirmModal({
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  danger = false,
  onConfirm,
  onClose,
}) {
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState("")

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) onClose()
  }

  React.useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose()
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [onClose])

  async function handleConfirm() {
    setError("")
    try {
      setLoading(true)
      await onConfirm()
    } catch (err) {
      setError(err?.message || "Não foi possível concluir a ação.")
      setLoading(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl">
        <div
          className={`flex items-center justify-between px-6 py-4 rounded-t-2xl ${
            danger ? "bg-red-600" : "bg-cor-base"
          }`}
        >
          <h2 className="text-xl font-oswald font-semibold text-white tracking-wide">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white text-2xl leading-none transition-colors"
            aria-label="Fechar"
            type="button"
          >
            ×
          </button>
        </div>

        <div className="px-6 py-5 grid gap-4">
          <p className="text-slate-700 text-sm">{message}</p>

          {error && (
            <p className="text-red-600 text-center text-sm font-semibold">{error}</p>
          )}

          <div className="flex gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 py-2.5 rounded-xl border-2 border-slate-200 text-slate-600 font-semibold hover:bg-slate-50 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={loading}
              className={`flex-1 py-2.5 rounded-xl text-white font-semibold transition-all disabled:opacity-60 disabled:cursor-not-allowed ${
                danger
                  ? "bg-red-600 hover:scale-[1.02] active:scale-[.97]"
                  : "bg-cor-base hover:scale-[1.02] active:scale-[.97]"
              }`}
            >
              {loading ? "Aguarde..." : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
